import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getGQLCareTeamList, saveNewCareTeamUser, saveExistingCareTeamUser } from "../../api/careTeam";

export const getCareTeamUserList = createAsyncThunk("careTeam/getCareTeamUserList", async (_, { rejectWithValue }) => {
  try {
    const response = await getGQLCareTeamList();
    return response?.body;
  } catch (error) {
    console.error({ error });
    return rejectWithValue(error);
  }
});

export const saveCareTeamUser = createAsyncThunk("careTeam/saveCareTeamUser", async (data, { rejectWithValue }) => {
  try {
    const response = await saveNewCareTeamUser(data);
    return JSON.parse(response?.body);
  } catch (error) {
    console.error({ error });
    return rejectWithValue(error);
  }
});

export const updateCareTeamUser = createAsyncThunk("careTeam/updateCareTeamUser", async (data, { rejectWithValue }) => {
  try {
    const response = await saveExistingCareTeamUser(data);
    return JSON.parse(response?.body);
  } catch (error) {
    console.error({ error });
    return rejectWithValue(error);
  }
});

export const getCareTeamById = createAsyncThunk("careTeam/getCareTeamById", async (data, { rejectWithValue }) => {
  return data;
});

const careTeamSlice = createSlice({
  name: "careTeam",
  initialState: {
    careTeamList: null,
    currentCareTeamEntity: null,
    rowCount: null,
    loading: false,
    error: null,
  },
  reducers: {
    resetState: (state) => {
      state.currentCareTeamEntity = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCareTeamUserList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCareTeamUserList.fulfilled, (state, action) => {
        state.loading = false;
        state.careTeamList = action.payload?.data;
        state.rowCount = action.payload?.rowCount;
        state.error = null;
      })
      .addCase(getCareTeamUserList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(saveCareTeamUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveCareTeamUser.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(saveCareTeamUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateCareTeamUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCareTeamUser.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(updateCareTeamUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getCareTeamById.pending, (state) => {
        state.loading = true;
        state.error = false;
      })
      .addCase(getCareTeamById.fulfilled, (state, action) => {
        state.loading = false;
        state.currentCareTeamEntity = action.payload;
      })
      .addCase(getCareTeamById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
  },
});

export const { resetState } = careTeamSlice.actions;
export default careTeamSlice.reducer;